import { NavLink } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { LogOut } from "lucide-react";
import { Button } from "./ui/button";
import { useHeader } from "../hooks/useHeader";
import { HeaderProps } from "../@types/props.types";
import HeaderProfileBlock from "./HeaderProfileBlock";
import { BonusBalance } from "./features/BonusBalance";
import { DepositBalance } from "./features/DepositBalance";

const Header = ({ menuTrigger }: HeaderProps) => {
  const { handleLogout } = useHeader();

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b bg-white">
      <div className="mx-auto flex h-16 max-w-6xl items-center px-4">
        {/* Лого - фиксированная ширина как у сайдбара */}
        <NavLink to={"/home"} className="flex items-center gap-3 md:w-[250px]">
          <img
            className="block h-10 min-h-10 w-10 min-w-10 object-contain"
            src={logo}
            alt="АкваСтар"
          />
          <span className="hidden text-xl font-semibold text-primary min-[500px]:inline-block">
            АкваСтар
          </span>
        </NavLink>

        {/* Правая часть */}
        <div className="flex flex-1 items-center justify-end gap-4">
          <div className="flex flex-col items-end gap-0.5 leading-tight">
            <DepositBalance />
            <BonusBalance />
          </div>
          <HeaderProfileBlock />
          <div className="hidden items-center gap-4 md:flex">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-destructive hover:bg-destructive/10 hover:text-destructive"
            >
              <LogOut className="mr-2 h-4 w-4" />
              Выйти
            </Button>
          </div>
          <div className="md:hidden">{menuTrigger}</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
